<template>
  <div class="upload-dialog-content" style="margin-top: 20px;">
    <el-upload action="https://jsonplaceholder.typicode.com/posts/"
               drag
               multiple
               :http-request="doUpload"
               :on-remove="onRemove"
               list-type="picture"
               :file-list="fileList">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">{{ $t('lang.common.uploadTip') }}</div>
      <div class="el-upload__tip" slot="tip">
        {{ $t('lang.applyList.pleaseUploadBankTransferVoucher') }}
      </div>
    </el-upload>
    <div class="bankinfo">
      <div class="accountcontent">
        {{
          $t('lang.submit.bankName') + (isZh ? bankTransferConfig.chinese.name : bankTransferConfig.english.name)
        }}<br/>
        {{
          $t('lang.submit.bankAddress') + (isZh ? bankTransferConfig.chinese.address : bankTransferConfig.english.address)
        }}<br/>
        {{
          $t('lang.submit.bankAccountName') + (isZh ? bankTransferConfig.chinese.accountName : bankTransferConfig.english.accountName)
        }}<br/>
        {{
          $t('lang.submit.bankAccountNo') + (isZh ? bankTransferConfig.chinese.accountNo : bankTransferConfig.english.accountNo)
        }}<br/>
        {{
          $t('lang.submit.bankTransferPurpose') + (isZh ? bankTransferConfig.chinese.transferPurpose : bankTransferConfig.english.transferPurpose)
        }}
      </div>
    </div>
    <div style="margin-top: 20px;">
      <el-button type="ceibsprimary" @click="doSubmit">{{ $t('lang.common.confirmUpload') }}</el-button>
    </div>
  </div>
</template>

<script>
import { confirmBankTransfer, listBankTransferVoucher } from '@/api/apply'
import { getBankTransferConfig, getFile, getFileByFileUrl, uploadFile } from '@/api/base'
import { mapGetters } from 'vuex'
import languageType from '@/locales/languageType'

export default {
  name: 'uploadBankTransferVoucher',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyVo: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'currentLanguage'
    ]),
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    }
  },
  data () {
    return {
      fileList: [],
      bankTransferConfig: {}
    }
  },
  mounted () {
    this.loadBankTransferConfig()
    this.loadApplyVo()
  },
  methods: {
    beforeClosed () {
      this.$emit('update:visible', false)
    },
    loadApplyVo () {
      if (this.applyVo) {
        listBankTransferVoucher({
          id: this.applyVo.id
        }).then(res => {
          this.fileList.splice(0)
          res.data.forEach(file => {
            getFile(file).then(blob => {
              if (blob) {
                this.fileList.push({
                  ...file,
                  name: file.fileName,
                  url: window.URL.createObjectURL(new Blob([blob]))
                })
              }
            })
          })
        })
      }
    },
    doUpload (params) {
      uploadFile(params.file, 'APPLY_BANK_TRANSFER_VOUCHER').then(res => {
        getFileByFileUrl(res.data).then(blob => {
          if (blob) {
            this.fileList.push({
              ...res.data,
              name: res.data.fileName,
              url: window.URL.createObjectURL(new Blob([blob]))
            })
          }
        })
      })
    },
    onRemove (file, fileList) {
      this.fileList = fileList
    },
    doSubmit () {
      if (this.fileList.length > 0) {
        confirmBankTransfer({
          ...this.applyVo,
          transferVoucherList: this.fileList
        }).then(res => {
          this.$message.success(this.$t('lang.applyList.uploadSuccess'))
          this.$emit('submit')
        })
      }
    },
    loadBankTransferConfig () {
      getBankTransferConfig().then(res => {
        this.bankTransferConfig = res.data
      })
    }
  }
}
</script>

<style scoped>
.dialogtitle {
  color: #a2100e;
}

.bankinfo {
  background-color: #ededed;
  padding: 15px;
  color: #707070;
  font-size: 14px;
  text-align: left;
  margin-top: 20px;
}
</style>
